import { useTranslation } from 'react-i18next';

import PasswordForm from '@/modules/auth/components/FormsContainer/Password/PasswordForm';
import Header from '@/modules/auth/components/Header';

const CreatePassword = () => {
  const { t } = useTranslation('login');

  return (
    <div className='flex flex-col gap-16'>
      <Header
        title={t('create-your-password')}
        subtitle={t('create-your-password-sub')}
      />
      <PasswordForm type='create' />
    </div>
  );
};

export default CreatePassword;
